(function ($, Drupal) {
  'use strict';

  var mac_early_access_email;
  var mac_early_access_sku_ids = [];
  var mac_early_access_open_popup = false;

  Drupal.behaviors.macEarlyAccessPopupV1 = {
    attach: function (context, settings) {
      var self = this;
      var thisSku;

      // commenting out this line for the ticket - CX-13155. This is a temporary fix and this has to be fixed
      // $(window).on('productApp:products_added', function(){
      $('.product--full, .product-full, .product--teaser, .shop-the-collection__carousel-item').each(function () {
        if (Drupal.settings.globals_variables.enable_early_access) {
          thisSku = 'SKU' + $(this).find('.js-product-add-to-bag').attr('data-sku-base-id');
        } else {
          thisSku = $.parseJSON($(this).attr('data-product')).sku;
        }
        mac_early_access_sku_ids.push(thisSku);
        if (prodcat.data.getSku(thisSku).RESTRICT_GROUP) {
          mac_early_access_open_popup = true;
        }
      });
      if (mac_early_access_open_popup) {
        self.macEarlyAccessRestriction();
      }
      // });
    },

    macEarlyAccessShowPopup: function ($selector) {
      $('.js-mac-early-access-popup-section').addClass('hidden');
      $selector.removeClass('hidden');
      $.colorbox.resize();
    },

    macEarlyAccessValidateLoyalty: function (email) {
      /**
       * validate loyalty status
       */
      var self = this;

      generic.jsonrpc.fetch({
        method: 'user.validateEarlyAccess',
        params: [
          {
            'email_address': email,
            'prod_ids': mac_early_access_sku_ids
          }
        ],
        onSuccess: function (result) {
          var responseData = result.getValue();
          var $add_to_bag = $('.product__add-to-bag, .js-product-add-to-bag');
          var $pointsRequired = $('.js-required-points');

          $add_to_bag.attr('disabled', 'disabled').addClass('loyalty-disabled');
          if (responseData.allowed_to_buy === 1) {
            // loyalty user
            if (responseData.grandfather_status === 1 || responseData.pro_member === 1) {
              self.macEarlyAccessShowPopup($('.js-mac-early-access-congratulation'));
              $add_to_bag.removeAttr('disabled').removeClass('loyalty-disabled');
            } else if (responseData.grandfather_status === -1) {
              // Elite member. redirect to  /account/select.tmpl page with pop-up
              self.macEarlyAccessShowPopup($('.js-mac-early-access-elite'));
            } else {
              // sorry message
              self.macEarlyAccessShowPopup($('.js-mac-early-access-check-back-soon'));
            }
          } else if (responseData.eligible === 0) {
            // Earn More message
            $pointsRequired.html(responseData.needed_points);
            self.macEarlyAccessShowPopup($('.js-mac-early-access-earn-more'));
          } else {
            // sorry message
            self.macEarlyAccessShowPopup($('.js-mac-early-access-check-back-soon'));
          }
        }
      });
    },

    /**
     * Display pop-up if camapign exists
     */
    macEarlyAccessColorbox: function () {
      generic.overlay.launch({
        content: $('.mac-early-access-popup').html(),
        includeBackground: true,
        initialHeight: 0,
        height: 0,
        width: '40%',
        className: 'mac-early-access-popup-colorbox js-mac-early-access-popup-colorbox',
        closeButton: Drupal.settings.globals_variables.enable_early_access ? true : false,
        overlayClose: false,
        escKey: false,
        onComplete: function () {
          var $colorboxSelector = $('.js-mac-early-access-popup-colorbox');
          var sign_in_class = '.js-mac-early-access-sign-in';
          var $signInSelector = $colorboxSelector.find(sign_in_class);

          // Pre populate email field
          if (mac_early_access_email !== undefined) {
            $colorboxSelector.find('input[name="EMAIL_ADDRESS"]').val(mac_early_access_email);
          }
          // Close color box on success pop-up
          $colorboxSelector.find('.js-mac-early-access-congratulation .mac-early-access-popup__congratulation-button').click(function (e) {
            e.preventDefault();
            $.colorbox.close();
          });

          $signInSelector.find('input[name="RETURN_URL"]').val(window.location.pathname);
          var $signinForm = $signInSelector.find('form[name="signin"]');

          $signinForm.attr('action', 'https://' + window.location.host + $signinForm.attr('action'));
        }
      });
    },

    /**
     *  Display popups based on sign in status
     */
    macEarlyAccessRestriction: function () {
      var self = this;

      generic.jsonrpc.fetch({
        method: 'user.json',
        params: [{}],
        onSuccess: function (jsonRpcResponse) {
          self.macEarlyAccessColorbox();
          var user_info = jsonRpcResponse.getValue();

          if (user_info.signed_in) {
            self.macEarlyAccessValidateLoyalty(user_info.email_address);
          } else {
            // get email from query string
            var query_strings = document.location.search.substr(1).split('&');

            for (var i in query_strings) {
              var q_split = query_strings[i].split('=');

              if (q_split[0] == 'PC_EMAIL_ADDRESS') {
                mac_early_access_email = q_split[1];
              }
            }
            self.macEarlyAccessShowPopup($('.js-mac-early-access-sign-in'));
            if (Drupal.settings.globals_variables.enable_early_access) {
              var $add_to_bag = $('.js-product-add-to-bag');

              $add_to_bag.addClass('loyalty-disabled');
            }
          }
        }
      });
    }
  };
})(jQuery, Drupal);
